// // Custom JS for Regina Ward

jQuery(document).ready(function ($) {

    var skipLink = function () {
        $(".skiplink").focusin(function () {
            $(this).css("position","static");
        });

        $(".skiplink").focusout(function () {
            $(this).css("position","absolute");
        });
    }

    //No comments
    $("#commentform").addClass("noauto");


    $('.entry-content table').addClass('table').wrap('<div class="table-responsive"></div>');

    $('#disclaimerCheck').click(function() {
       $('.disclaimer').fadeOut('slow');
       $(".no-disclaimer").css("opacity",1);
       $(".testimonial-border").css("height",$(".no-disclaimer").height()+ 110);
       $('.testimonial-wrapper').removeClass('no-disclaimer');
    });

    /*if($(window).width() > 1199){
        $( ".page-template-practice-area-alt .third-section ul" ).prevAll( "p" ).css( "padding-right", 321 );
        $( ".page-template-practice-area-alt .third-section .col-sm-6" ).prevAll( "p" ).css( "padding-right", 321 );
    }*/

    if($(window).width() < 992){
        $('.nav-pills').click(function(){
          if($(this).find(".active a").attr('id')=="linkConway") {
            $('.footer-maps .wpseo-location').css("background-image", "url('/wp-content/themes/cws-theme-work/images/backgrounds/map-home2.jpg')");
          }
          else {
            $('.footer-maps .wpseo-location').css("background-image", "url('/wp-content/themes/cws-theme-work/images/backgrounds/map-home1.jpg')");
          }
        });
    }

    $(".wpseo-location-1").css("padding-left",$("#menu-footer-menu").offset().left);

    if($(window).width() > 1199){
        $(".sidebox-featured-generic-border").css("height",$(".sidebox-featured-generic img").height()+ 40);
        $(".sidebox-featured-generic-border").css("border","1px solid #b3b08f");
    }

    $("#meet-team .attorney-list").slick({
            slidesToShow: 5,
            infinite: true,
            autoplay: false,
            slidesToScroll: 5,
            prevArrow: '<span class="icon icon-chevron-left"></span>',
            nextArrow: '<span class="icon icon-chevron-right"></span>',
            appendArrows: '.customNavigationAttorneys',
            dots: false,
            arrows: true,
            responsive: [
                {
                  breakpoint: 1199,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    centerMode: false
                  }
                },
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: false
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: false
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        });


    var Ward = (function () {

        var sameHeight = function () {

            $('.sameHeight').matchHeight();

        };

        var withBg = function () {

            $('.with-bg').each(function () {

                var bg_ = 'url(' + $(this).find('> img').attr('src') + ')';
                $(this).find('> img').hide();
                $(this).css('background-image', bg_);  

            });

        };

        var smoothScroll = function () {
            $('.box-jumpto').smoothScroll();
            $('.info-details').smoothScroll();
            $('.text-right').smoothScroll();
            $('.text-center').smoothScroll();
        };

        var initVideo = function () {

            $('a.video-link').click(function () {

                $('a.video-link').removeClass('active');
                $(this).addClass('active');

                var id = $(this).attr('data-youtube');
                var src = '//www.youtube.com/embed/' + id;
                var iframe = '<iframe id="youtube" width="560" height="315" frameborder="0" src="' + src + '" allowfullscreen></iframe>';
                $(".playlist-video-wrap").addClass('active').html(iframe);
                return false;
            });

            var counter = 0;

            $('.video-wrap').on('click', function () {

                var that = this;

                var video_src = '';
                var video_src_play = '';
                var video_src = $(this).find('.cw_video_single').attr('src');

                if (counter == 0) {
                    video_src_play = $(this).find('.cw_video_single').attr('src') + 1;
                };

                counter = 1;

                $(that).find('.cw_video_single').attr('src', video_src_play);

                $(that).find('.img-poster').fadeOut('slow');
                $(that).find('.btn-play').fadeOut('slow');

            });

        };



        var slickAwards = function () {

            var $sa = $('.slick-awards');

            // init slick and remove innerHTML from prev/next
            $sa.on('init reInit', function(event, slick) {

                $('.slick-awards .slick-prev').html('');
                $('.slick-awards .slick-next').html('');

            });

            $('.slick-awards').slick({
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 6,
                slidesToScroll: 6,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: false,
                            variableWidth: true,
                        }
                    },
                     {
                      breakpoint: 991,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        centerMode: false,
                        variableWidth: true,
                      }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            variableWidth: true,
                            centerMode: true,
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                        centerMode: true
                      }
                    }

                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object

                ]

            });

        };

        var ToC ="<ul>";

        var newLine, el, title, link;

        $(".toc-heading").each(function() {

              el = $(this);
              title = el.text();
              link = "#" + el.attr("id");

              newLine =
                "<li>" +
                  "<a class='toc-link' href='" + link + "'>" +
                    title +
                  "</a>" +
                "</li>";

              ToC += newLine;

        });

        ToC +=
           "</ul>" +
          "</nav>";

        $(".toc-wrap").prepend(ToC);

        //Toc link clic
        $( '.toc-link' ).on( 'click', function(e) {
            var goTo = $(this).attr('href');
            $('html,body').animate({ scrollTop: $(goTo).offset().top }, 600);

        });

        //grab vid on click
    $( '#select li a' ).click(function( e ) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: cws.ajaxurl,
            data: {
                action:       'cws_video_ajax_callback',
                video_select: $( this ).attr( 'data-code' )
            },
            dataType: 'json',

            beforeSend: function() {
            },

            success: function (response) {

                if( response.success === true ) {

                    $( '.video-content' ).html(response.data.shortCode);
                    var $frame = $('#practices-videos .video-content iframe');
                    $frame.attr('src',$frame.attr('data-src'));
                    $frame.attr("src", $frame.attr("src").replace("autoplay=", "autoplay=1"))

                } else if( response.success === false ) {
                    $( '.loader' ).hide();
                    alert( response.data );
                }
            },
        });
    });

        var slickTestimonials = function () {

            // function to make numbers include 0
            var two = function(e) {
                return (e).toLocaleString(undefined, {minimumIntegerDigits: 2});
            };

            var $ts = $('.testimonials-slick');

            // init slick and remove innerHTML from prev/next, set init slide counts, 
            // and hide the prev button
            $ts.on('init reInit', function(event, slick) {

                // counts all slick items (minus the clones) 
                var numSlides = $ts.find('.slick-item').length - $ts.find('.slick-cloned').length;

                $('.testimonial-wrapper .slick-prev').html('');
                $('.testimonial-wrapper .slick-next').html('');
                $('.testimonial-wrapper .slick-prev').hide();
                $('.testimonial-slick-count .currentSlide').html(two(1));
                $('.testimonial-slick-count .totalSlides').html(two(numSlides));

            });

            $ts.slick({
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,

            });

            $(".testimonials-slick .slick-prev").detach().appendTo(".testimonial-slick-nav");
            $(".testimonials-slick .slick-next").detach().appendTo(".testimonial-slick-nav");

            // change slide count, show prev button
            $ts.on('afterChange', function(event, slick, currentSlide){
                var count = (currentSlide ? currentSlide : 0) + 1;
                $('.testimonial-wrapper .slick-prev').show();
                $('.testimonial-slick-count .currentSlide').html(two(count));

            });

        };

        var requiredInput = function () {

            $('.input-email').on('focus', function () {
                if ($(this).parent().data('required') == 'required') {
                    $(this).parent().removeClass('required');
                }
            });

            $('.input-email').on('blur', function () {
                if ($(this).val() == '') {
                    $(this).parent().addClass('required');
                }
            });

        };

        var faqs = function () {

            $('.qa-faq-anchor').on('click',function (e) {
                e.preventDefault();

                if( $(this).hasClass('active') ) {
                    $('.qa-faq-anchor').removeClass('active');
                } else {
                    $('.qa-faq-anchor').removeClass('active');
                    $(this).addClass('active');
                }

            });

        };

        var datePicker = function () {

            var icons = {
                up: 'icon icon-green-arrow-up',
                down: 'icon icon-green-arrow-down',
                previous: 'icon icon-green-arrow-left',
                next: 'icon icon-green-arrow',
                today: '',
                clear: '',
                close: ''
            };

            $('#datepicker-1').datetimepicker({
                collapse: true,
                sideBySide: false,
                inline: false,
                keepOpen: false,
                debug: false,
                icons: icons
            });

            $('#timepicker-1').datetimepicker({
                format: 'LT',
                icons: icons
            });        

        };

        return {
            init: function () {
                sameHeight();
                withBg();
                smoothScroll();
                initVideo();
                slickAwards();
                slickTestimonials();
                requiredInput();
                faqs();
                datePicker();
            }
        }

    })();

    Ward.init();

});

